import { Model } from "./model";
import { User } from "./user";
import { Template } from "./template";

export class CommSend extends Model {

  constructor(
    public id?: number,
    public userId?: number,
    public templateId?: number,
    public user: User = null,
    public processedAt: Date = null,
    public description: string = null,
    public numberOfRecipients: number = null,
    public messageBody: string = null,
    public template: Template = null,

    public isShowingEmailReceipts: boolean = false,

    public createdAt: Date = null,
    public updatedAt: Date = null,
  ) { super(); }

  static clone(obj: any) {
    const o = new this()

    if (obj.id) { o.id = obj.id }
    if (obj.userId) { o.userId = obj.userId }
    if (obj.templateId) { o.templateId = obj.templateId }
    if (obj.user) { o.user = User.clone(obj.user) }
    if (obj.processedAt) { o.processedAt = new Date(obj.processedAt) }
    if (obj.description) { o.description = obj.description }
    if (obj.numberOfRecipients) { o.numberOfRecipients = obj.numberOfRecipients }
    if (obj.messageBody) { o.messageBody = obj.messageBody }

    if (obj.template) { o.template = Template.clone(obj.template) }

    if (obj.updatedAt) { o.updatedAt = new Date(obj.updatedAt) }
    if (obj.createdAt) { o.createdAt = new Date(obj.createdAt) }

    return o
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/models/comm-send.ts